import { request } from "./client";

// Backend now applies the global "/api" prefix to auth routes too (matches
// every other controller) — no more special-casing needed here. If auth
// calls ever start 404ing again, first check whether the backend's
// setGlobalPrefix('api', { exclude: [...] }) exclusion list still lists
// 'auth' before assuming the frontend is wrong.

export const requestMagicLink = (email) =>
  request("/auth/magic-link", {
    method: "POST",
    body: JSON.stringify({ email }),
  });

export const verifyMagicLink = (id, token) =>
  request(
    `/auth/magic-link/verify?id=${encodeURIComponent(id)}&token=${encodeURIComponent(token)}`,
  );

export const googleLogin = (idToken) =>
  request("/auth/google", {
    method: "POST",
    body: JSON.stringify({ idToken }),
  });

export const getCurrentUser = () => request("/auth/me");
export const getMe = getCurrentUser;

// NOTE: as of this fix, no backend route matches POST /auth/wallet/connect —
// grep of every *.controller.ts in chicago-backend-main turns up nothing.
// The nearest equivalent is POST /api/seasons/:id/register-wallet
// (season-allocation.controller.ts), a different shape (needs a season id).
// Left as-is rather than guess-wired; confirm the intended endpoint with the
// backend dev before this is called anywhere in the UI.
export const connectWallet = (address) =>
  request("/auth/wallet/connect", {
    method: "POST",
    body: JSON.stringify({ address }),
  });

export const getPresignedUrl = ({ fileName, contentType, type }) => {
  if (
    import.meta.env.VITE_API_BASE_URL &&
    !import.meta.env.VITE_API_BASE_URL.startsWith("http")
  ) {
    throw new Error(
      "VITE_API_BASE_URL must start with https:// — check your Vercel environment variables",
    );
  }
  return request("/uploads/presigned-url", {
    method: "POST",
    body: JSON.stringify({ fileName, contentType, type }),
  });
};
